<template>
  <div class="flex overflow-hidden h-screen bg-gray-100 select-none">
    <div v-if="isNavbarShown" class="md:hidden">
      <div
        class="fixed inset-0 z-30 transition-opacity duration-300 ease-linear bg-blur-5"
        :class="isNavbarExtended ? 'opacity-100' : 'opacity-0'"
      >
        <div class="absolute inset-0 bg-gray-600/75" />
      </div>
      <div class="flex fixed inset-0 z-40">
        <div
          class="flex flex-col flex-1 bg-white transition duration-300 ease-in-out transform p-safe"
          style="min-width: 16rem;"
          :class="!isNavbarExtended && '-translate-x-full'"
        >
          <div class="absolute top-0 right-0 p-1 -mr-14">
            <button
              class="flex justify-center items-center w-12 h-12 focus:bg-gray-600 rounded-full transition-opacity duration-300 ease-linear focus:outline-none"
              :class="isNavbarExtended ? 'opacity-100' : 'opacity-0'"
              @click="hideMenu"
            >
              <svg
                class="w-6 h-6 text-white"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div class="flex overflow-y-auto flex-col flex-1 pt-6 pb-2 h-0">
            <router-link
              to="/landing"
              class="flex flex-shrink-0 items-center px-4 space-x-2"
            >
              <img class="w-auto h-8" src="@/assets/logo.svg">
              <span class="text-xl font-medium leading-0">bacchus<span class="text-primary-700">.</span>Tracker</span>
            </router-link>
            <nav class="flex-1 px-2 mt-5">
              <router-link
                v-for="entry of entries"
                :key="entry.to"
                :to="entry.to"
                class="flex items-center py-3 px-3 mt-1 text-sm font-medium leading-none text-gray-800 rounded-md transition duration-150 ease-in-out focus:outline-none"
                activeClass="bg-gray-200 text-primary-700"
              >
                <i class="mr-3 text-lg leading-none far fa-fw" :class="entry.icon" />{{ entry.title }}
              </router-link>
            </nav>
            <nav class="px-2">
              <router-link
                v-for="entry of footer"
                :key="entry.to"
                :to="entry.to"
                class="flex items-center py-3 px-3 mt-1 text-sm font-medium leading-none text-gray-800 rounded-md transition duration-150 ease-in-out focus:outline-none"
                activeClass="bg-gray-200 text-primary-700"
              >
                <i class="mr-3 text-lg leading-none far fa-fw" :class="entry.icon" />{{ entry.title }}
              </router-link>
            </nav>
          </div>
          <div class="flex flex-shrink-0 justify-around py-4 px-4 space-x-4 text-gray-700 border-t border-gray-200">
            <div v-if="battery">
              <i
                class="mr-1 opacity-50 far fa-fw"
                :class="battery.isCharging ? 'fa-battery-bolt' : 'fa-battery-three-quarters'"
              />
              <span v-text="battery.level" /><span class="opacity-75">%</span>
            </div>
            <div>
              <i class="mr-1 opacity-50 far fa-fw fa-clock" />
              <span v-text="formatedTime" />
            </div>
          </div>
        </div>
        <div
          class="flex-shrink-0 w-full"
          style="min-width: 3.5rem;"
          @click="hideMenu"
        />
      </div>
    </div>

    <div class="hidden md:flex md:flex-shrink-0">
      <div class="flex flex-col w-64 border-r">
        <div class="flex overflow-y-auto flex-col flex-1 pt-6 pb-2 h-0">
          <router-link
            to="/landing"
            class="flex flex-shrink-0 items-center px-4 space-x-2"
          >
            <img class="w-auto h-8" src="@/assets/logo.svg">
            <span class="text-xl font-medium leading-0">bacchus<span class="text-primary-700">.</span>Tracker</span>
          </router-link>
          <nav class="flex-1 px-2 mt-5 text-gray-800">
            <router-link
              v-for="entry of entries"
              :key="entry.to"
              v-slot="{ isActive }"
              :to="entry.to"
              class="flex items-center py-3 px-3 mt-1 text-sm font-medium leading-none rounded-md transition duration-150 ease-in-out focus:outline-none"
              activeClass="bg-gray-200 text-primary-700"
            >
              <i
                class="mr-3 text-lg leading-none far fa-fw"
                :class="[entry.icon, !isActive && 'opacity-50']"
              />{{ entry.title }}
            </router-link>
          </nav>
          <nav class="px-2 text-gray-800">
            <router-link
              v-for="entry of footer"
              :key="entry.to"
              v-slot="{ isActive }"
              :to="entry.to"
              class="flex items-center py-3 px-3 mt-1 text-sm font-medium leading-none rounded-md transition duration-150 ease-in-out focus:outline-none"
              activeClass="bg-gray-200 text-primary-700"
            >
              <i
                class="mr-3 text-lg leading-none far fa-fw"
                :class="[entry.icon, !isActive && 'opacity-50']"
              />{{ entry.title }}
            </router-link>
          </nav>
        </div>
        <div class="flex flex-shrink-0 justify-around py-4 px-4 space-x-4 tabular-nums text-gray-700">
          <div v-if="isDeviceManaged">
            <i class="opacity-50 far fa-fw fa-chart-network" />
          </div>
          <div v-if="battery">
            <i
              class="mr-1 opacity-50 far fa-fw"
              :class="battery.isCharging ? 'fa-battery-bolt' : 'fa-battery-three-quarters'"
            />
            <span v-text="battery.level" /><span class="opacity-75">%</span>
          </div>
          <div>
            <i class="mr-1 opacity-50 far fa-fw fa-clock" />
            <span v-text="formatedTime" />
          </div>
        </div>
      </div>
    </div>

    <main
      class="flex overflow-y-auto relative z-0 flex-col flex-1 focus:outline-none"
      tabindex="0"
    >
      <div class="flex flex-shrink-0 items-center px-6 pt-safe-or-5">
        <h1
          v-if="title"
          class="text-2xl font-semibold leading-normal text-gray-900"
        >
          <i
            v-if="icon"
            class="mr-3 text-gray-600 fal fa-fw"
            :class="icon"
          />
          <span v-text="title" />
        </h1>
        <div class="flex-grow" />
        <slot name="header" />
        <router-link
          v-if="!isOnLanding"
          class="inline-flex md:hidden flex-shrink-0 justify-center items-center -mt-0.5 ml-4 w-12 h-12 text-gray-500 hover:text-gray-900 focus:bg-gray-200 rounded-md transition duration-150 ease-in-out focus:outline-none"
          to="/landing/"
          @click="showMenu"
        >
          <i class="far fa-home text-inherit" />
        </router-link>
        <button
          class="inline-flex md:hidden flex-shrink-0 justify-center items-center -mt-0.5 ml-4 w-12 h-12 text-gray-500 hover:text-gray-900 focus:bg-gray-200 rounded-md transition duration-150 ease-in-out focus:outline-none"
          @click="showMenu"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>
      <tabbar v-if="tabs" :tabs="tabs" />
      <slot name="full">
        <div :class="containerClass">
          <slot />
        </div>
      </slot>
    </main>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Tabbar from './tabbar.vue'

  export default {
    name: 'PageContainer',
    components: { Tabbar },
    props: {
      icon: { type: String, required: false },
      title: { type: String, required: false },
      tabs: { type: Object, required: false },
      containerClass: { type: String, required: false, default: 'py-6 px-6 flex-1' }
    },
    data () {
      return {
        isNavbarShown: false,
        isNavbarExtended: false,
        entries: [
          { to: '/landing/', title: this.$t('Overview'), icon: 'fa-home' },
          { to: '/campaigns/', title: this.$t('Campaigns'), icon: 'fa-route' },
          { to: '/manually/', title: this.$t('ManualWork'), icon: 'fa-clipboard-check' },
          { to: '/map/', title: this.$t('FieldMap'), icon: 'fa-map-marked-alt' }
        ],
        footer: [
          { to: '/data/', title: this.$t('OfflineData'), icon: 'fa-database' },
          { to: '/settings/', title: this.$t('Settings'), icon: 'fa-cogs' },
          { to: '/device/', title: this.$t('DeviceInfos'), icon: 'fa-tablet-android' }
        ]
      }
    },
    computed: {
      isOnLanding () { return this.$route.fullPath === '/landing/' },
      ...mapState({
        now: state => state.device.now,
        isDeviceManaged: state => state.device.isManaged,
        battery: state => state.device.battery
      }),
      formatedTime () { return (new Date(this.now)).toTimeString().slice(0, 5) },
      isSidebarVisible () { return this.$route.meta.hideSidebar !== true }
    },
    methods: {
      showMenu () {
        if (!this.isSidebarVisible) return
        this.isNavbarShown = true
        this.isNavbarExtended = false

        setTimeout(() => { this.isNavbarExtended = true }, 50)
      },
      hideMenu () {
        if (!this.isSidebarVisible) return
        this.isNavbarExtended = false

        setTimeout(() => { this.isNavbarShown = false }, 300)
      }
    }
  }
</script>
